<template>
  <div v-if="show" class="export-modal-overlay" @click.self="handleClose">
    <div class="export-modal-content">
      <div class="export-modal-header">
        <div class="export-modal-title-wrapper">
          <i class="bi bi-download export-modal-title-icon"></i>
          <h3>{{ title }}</h3>
        </div>
        <button class="export-modal-close" @click="handleClose">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="export-modal-body">
        <p class="export-modal-description">{{ description }}</p>
        <div class="export-format-options">
          <button class="export-format-btn" @click="handleExcelExport">
            <div class="export-format-icon-wrapper">
              <i class="bi bi-file-earmark-excel"></i>
            </div>
            <span class="export-format-label">Export to Excel</span>
            <small class="export-format-subtitle">.xlsx format</small>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Export'
    },
    description: {
      type: String,
      default: 'Choose your preferred export format to download the data'
    }
  },
  emits: ['close', 'export-excel'],
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleExcelExport() {
      this.$emit('export-excel');
    }
  }
}
</script>

<style scoped>
@import './ExportModal.css';
</style>

